// src/firebase/services.js
import { collection, doc, addDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebaseConfig";

export const submitRegisterForm = async (data) => {
  try {
    await addDoc(collection(db, "registrations"), {
      ...data,
      createdAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Lỗi ghi dữ liệu:", error);
    throw error;
  }
};


export const getSiteInfo = async () => {
  const docRef = doc(db, "site_info", "siteInfo");
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    console.error("Site info not found!");
    return null;
  }
};

